// extracted by css-extract-rspack-plugin
export default {"wrapper":"_7814ab01"};